import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataTransportadorasReducer } from "../reducers";
import { InitialStateTransportadoras } from "../models/transportadoras.model";

const initialState: InitialStateTransportadoras = {
  items: [],
  itemsApelidos: [],
  itemsDiretoriosKitColeta: [],
  dialogForm: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  requestGetParams: {},
  pagination: {
    page: 1,
    rowsPerPage: 15,
    totalPages: 0,
    totalItems: 0,
  },
};

const transportadorasSlice = createSlice({
  name: "transportadorasApp/transportadoras",
  initialState,
  reducers: {
    openDialogForm: (state, action) => {
      state.dialogForm = {
        open: true,
        content: action.payload,
      };
    },
    closeDialogForm: (state) => {
      state.dialogForm = {
        open: false,
        content: {
          mode: "",
          values: null,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      Actions.getTransportadoras.fulfilled,
      dataTransportadorasReducer
    );
  },
});

export const { openDialogForm, closeDialogForm } = transportadorasSlice.actions;

export default transportadorasSlice.reducer;
